<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-text-field v-model="form.email" :error-messages="emailErrors" label="E-mail" required></v-text-field>

					<v-text-field v-model="form.password" :type="'password'" :error-messages="passwordErrors" label="Password" required></v-text-field>
					<v-text-field v-model="form.confirmPassword" :type="'password'" :error-messages="confirmPasswordErrors" label="Confirm Password" required></v-text-field>
					<v-subheader class="text-xs-left"> Requirements: A password that is at least 8 to 64 characters. It requires 3 out of 4 of lowercase, uppercase, numbers, or symbols. </v-subheader>
					<v-checkbox v-model="form.notifyEmployee" label="Email login details to employee"></v-checkbox>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn color="primary" flat @click="submit" :loading="isSaving">{{ isSaving ? "Saving..." : "Save" }}</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';

	export default {
		props: {
			dialog: {
				required: true
			},
			title: {
				required: true
			},
			email: {
				required: true
			},
			isAdmin: {
				required: false
			},
			isSaving: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {
				form: {
					email: this.email,
					password: null,
					confirmPassword: null,
					isAdmin: false,
					notifyEmployee: true
				}
			};
		},
		watch: {
			email() {
				this.form.email = this.email;
			}
		},
		methods: {
			closeEditor() {
				this.$emit('closeEditor');
			},
			submit() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let roles = [];
					if (this.form.isAdmin && this.isAdmin) {
						roles.push('admin');
					}

					let postObj = {
						email: this.form.email,
						password: this.form.password,
						roles: roles,
						notifyEmployee: this.form.notifyEmployee
					};
					this.$emit('save', postObj);
				}
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					password: null,
					isAdmin: false,
					confirmPassword: null
				};
			}
		},
		mixins: [validationMixin],

		validations: {
			form: {
				password: { required, minLength: minLength(8) },
				isAdmin: {},
				email: { required, email },
				confirmPassword: {
					required,
					sameAsPassword: sameAs('password')
				}
			}
		},
		computed: {
			passwordErrors() {
				const errors = [];
				if (!this.$v.form.password.$dirty) return errors;
				!this.$v.form.password.required && errors.push('Password is required');
				!this.$v.form.password.minLength && errors.push('Password must be at least 8 characters');
				return errors;
			},
			confirmPasswordErrors() {
				const errors = [];
				if (!this.$v.form.confirmPassword.$dirty) return errors;
				!this.$v.form.confirmPassword.required && errors.push('Confirm password is required');
				!this.$v.form.confirmPassword.sameAsPassword && errors.push('Passwords do not match');
				return errors;
			},
			emailErrors() {
				const errors = [];
				if (!this.$v.form.email.$dirty) return errors;
				!this.$v.form.email.email && errors.push('Must be valid e-mail');
				!this.$v.form.email.required && errors.push('E-mail is required');
				return errors;
			}
		}
	};
</script>

<style></style>
